export const THEME_COLOR_SET = {
  default: '#ffffff', //add by lau
  primary: '#00A4F2',
  purple: '#995efc',
  slate: '#4F62FF', //modify by lau 前值:@6575ff
  aqua: '#29c3ff',
  turquoise: '#00cbb8',
  tomato: '#ffaa10',
  orange: '#ff8225',
  yellow: '#ff6a4c',
  gray: '#7C879B' //modify by lau 前值:dark:@000000
}

//add by lau
export const THEME_BOX_BGCOLOR_SET = {
  primary: '#3c87ff',
  purple: '#a36efc',
  slate: '#6072ff',
  aqua: '#3ec9ff',
  turquoise: '#1ad0bf',
  tomato: '#ffb228',
  orange: '#ff8e3b',
  yellow: '#ff795e',
  gray: '#8993a5'
}



// WEBPACK FOOTER //
// ./theme/config.js